function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Grid_1_"
}, React.createElement("g", {
  id: "Grid"
}, React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M323.1 1v350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M440 1v350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M556.9 1v350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M673.8 1v350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#fb7d74",
  strokeMiterlimit: 10,
  d: "M698.1 1v350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M207.6 1v350"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(50.286 284.87)"
}, "10M"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(67.394 355)"
}, "0"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(47.595 214.74)"
}, "20M"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(47.647 144.611)"
}, "30M"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(46.386 74.482)"
}, "40M"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(1.068 10.626)"
}, "Population"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(91.268 378.753)"
}, "2010"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(307.14 378.753)"
}, "2020"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(193.544 378.753)"
}, "2015"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(424.664 378.753)"
}, "2025"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(540.967 378.753)"
}, "2030"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(658.492 378.753)"
}, "2035"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(757.544 378.753)"
}, "2040"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M92 316h698"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M92 281h698"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M92 246h698"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M92 211h698"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M92 176h698"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M92 141h698"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M92 106h698"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M92 71h698"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M92 36h698"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M92 36h698"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91.3 1h699.5v350H91.3z"
}), React.createElement("path", {
  fill: "#fb7d74",
  d: "M684.8 165h50.6v22h-50.6z"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(694.496 179.816)"
}, "2036")), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M790.7 1v350"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "Line",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 5.035,
  d: "M92 175l23.3-3 23.3-3 23.4-3 23.3-3.1 23.3-3.1 23.3-3.2 23.4-3.2 23.3-3.3 23.3-3.3 23.3-3.4 23.4-3.4 23.3-3.5 23.3-3.5 23.3-3.6 23.4-3.6 23.3-3.7 23.3-3.7 23.3-3.8 23.4-3.8 23.3-3.8 23.3-3.9 23.3-3.9 23.4-3.9 23.3-4 23.3-4 23.3-4.1"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Top_x5F_label"
}, React.createElement("path", {
  fill: "#fff",
  d: "M648.8 42.6h83v22h-83z"
}), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(656.109 57.364)"
}, "38 million"));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "Bottom_x5F_label"
}, React.createElement("path", {
  fill: "#fff",
  d: "M108.8 183h83v20.9h-83z"
}), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(116.16 197.316)"
}, "25 million"));

var SvgS15DesktopColors = function SvgS15DesktopColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "viz",
    x: 0,
    y: 0,
    viewBox: "0 0 800 400",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default "data:image/svg+xml;base64,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";
export { SvgS15DesktopColors as ReactComponent };